/**
 * Snapshot / restore de cámara MapLibre para volver al mapa país
 * después de encuadrar un showroom CAD desde Listas.
 */

export function snapshotMapCamera(map) {
  if (!map || typeof map.getCenter !== 'function') return null;
  const center = map.getCenter();
  return {
    center: { lng: center.lng, lat: center.lat },
    zoom: map.getZoom(),
    bearing: map.getBearing(),
    pitch: map.getPitch(),
  };
}

export function restoreMapCamera(map, camera, { duration = 700 } = {}) {
  if (!map || !camera || typeof map.easeTo !== 'function') return;
  map.easeTo({
    center: [camera.center.lng, camera.center.lat],
    zoom: camera.zoom,
    bearing: camera.bearing,
    pitch: camera.pitch,
    duration,
  });
}
